import { Link, useParams } from "react-router-dom";
import { newsList } from "@/mocks/news";
import Breadcrumb from "@/components/feature/Breadcrumb";
import NewsCard from "@/components/feature/NewsCard";
import EmptyState from "@/components/feature/EmptyState";
import { usePageMeta } from "@/hooks/usePageMeta";

const wrap = "mx-auto w-full max-w-[1280px] px-4 md:px-6";

export default function NewsDetailPage() {
  const { id = "" } = useParams();
  const item = newsList.find((n) => n.id === id);

  usePageMeta(
    item ? `${item.title} - 影视资讯 - 泰剧腐剧双男主` : "资讯详情 - 泰剧腐剧双男主",
    item?.summary,
  );

  if (!item) {
    return (
      <div className={`${wrap} py-20`}>
        <EmptyState
          icon="ri-newspaper-line"
          title="没有找到这篇资讯"
          description="该资讯可能已被移除，去看看其他最新内容吧。"
        />
        <div className="mt-6 text-center">
          <Link
            to="/news"
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            返回资讯列表
          </Link>
        </div>
      </div>
    );
  }

  const related = newsList.filter((n) => n.id !== item.id).slice(0, 3);

  return (
    <div className={wrap}>
      <div className="pt-6">
        <Breadcrumb
          items={[{ label: "首页", to: "/" }, { label: "影视资讯", to: "/news" }, { label: item.category }]}
        />
      </div>

      <article className="mx-auto mt-6 max-w-3xl">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
          <i className="ri-price-tag-3-line"></i>
          {item.category}
        </span>
        <h1 className="mt-4 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
          {item.title}
        </h1>
        <div className="mt-3 flex flex-wrap items-center gap-4 text-sm text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-calendar-line"></i>
            {item.date}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-user-line"></i>
            泰剧腐剧双男主编辑部
          </span>
        </div>

        <div className="mt-6 h-56 w-full overflow-hidden rounded-lg border border-background-200 bg-background-100 md:h-80">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 泰剧资讯配图`}
            className="h-full w-full object-cover object-top"
          />
        </div>

        <div className="mt-8 space-y-5">
          {item.content.map((paragraph, i) => (
            <p key={i} className="text-sm leading-loose text-foreground-700 md:text-base">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-3 border-t border-background-200 pt-6">
          <Link
            to="/news"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>返回资讯列表
          </Link>
          <Link
            to="/category/热门推荐"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-fire-line"></i>看看热门剧集
          </Link>
        </div>
      </article>

      <section className="mt-14 pb-4">
        <h2 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">相关资讯</h2>
        <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {related.map((n, i) => (
            <NewsCard key={n.id} item={n} index={i} />
          ))}
        </div>
      </section>
    </div>
  );
}